export default {
    computed: {
        $_customVuexName() {
            return this.customVuexName;
        },
        $_customVuexMixin_entity() {
            return this.customVuexName ? this.$_customVuexName + "Entity" : "entity";
        },
        $_customVuexMixin_filter() {
            return this.customVuexName ? this.$_customVuexName + "Filter" : "filter";
        },
        $_customVuexMixin_vo() {
            return this.customVuexName ? this.$_customVuexName + "Vo" : "rows";
        }
    },
    watch: {
        $_customVuexName() {
            this.$nextTick(() => {
                this.$refs.emListFilter.doQuery();
                this.$refs.viewTitle.getMenuTitleData();
            });
        }
    },
    methods: {
        insertHolder(param, val) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute(param + 'Filter', val);
            this.$refs.emTable.$_emCustomVuexMixin_setEntityAttribute(param, val)
            this.$refs.emListFilter.doQuery();
        },
        fromRouteParam() {
            if (this.$route.query.customVuexName) {
                this.customVuexName = this.$route.query.customVuexName;
            }
        }
    }
}